import type { InputGroupProps as _InputGroupProps } from "@chakra-ui/react";
import { forwardRef, InputGroup as _InputGroup } from "@chakra-ui/react";

export interface InputGroupProps extends _InputGroupProps {}

export const InputGroup = forwardRef<InputGroupProps, "div">(({ ...props }, ref) => (
    <_InputGroup ref={ref} {...props} />
));
